import { FelaCSS, colors } from '@bridebook/ui';
import { ISharedProps as IStyleProps } from './index';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = ({ color }: IStyleProps): IStyles => {
  const themeColor = color ? colors[color] : colors.rose;

  return {
    wrapper: {
      flexShrink: 0,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: '4px',
      paddingRight: '4px',
      height: '18px',
      fontDefault: 10,
      color: themeColor,
      border: `1px solid ${themeColor}`,
      borderRadius: '4px',
      whiteSpace: 'nowrap',
    },
  };
};

export default styles;
